import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup'; // For validation
import styles from './profilebody.module.css';
import api from '../../../../Website/utils/api';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { upadteCustomerProfileThunk } from '../../../../Website/redux/customerSlice';

const AccountSettings = () => {
    const [loading, setLoading] = useState(false)

    const {basicDetailsLoading,customer} = useSelector((state)=>state.customer)
       

    // console.log(customer?.fullName);
    
    const dispatch = useDispatch()
    const imageRef = useRef()
    const formik = useFormik({
        initialValues: {
            fullName: customer?.fullName || '',
            email:customer?.email || '',
            phone:customer?.phone || '',
            companyName:customer?.companyName || '',
            gstn:customer?.gstn || '',
            profileImg:customer?.profileImg || ''
        },
        validationSchema: Yup.object({
            fullName: Yup.string().required('Full Name is required'),
            email: Yup.string().email('Invalid email format').required('Email is required'),
            phone: Yup.string().required('Phone number is required'),
            companyName: Yup.string(),
            gstn: Yup.string(),

        }),
        onSubmit: (values) => {
            console.log('Form data:', values);
            dispatch(upadteCustomerProfileThunk(values))
        },
    });

 
    const handleImageChange = async (e, attribute) => {

        const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];

        setLoading(true);
        try {
            if (file) {

                const body = {
                    key: `${Date.now()}_${file.name}`,
                    fileType: file.type,
                    fileName: file.name,
                };

                const { data, status } = await api.getPutSignedUrl(body);
                // console.log(data);

                if (status === 200) {
                    await axios.put(data.data?.preSigned, file, {
                        headers: {
                            "Content-Type": file.type
                        }
                    })

                    formik.setFieldValue('profileImg', data?.data?.url)
                    
                    const updatedValues = {
                        fullName: formik.values.fullName || customer?.fullName || '',
                        email: formik.values.email || customer?.email || '',
                        phone: formik.values.phone || customer?.phone || '',
                        companyName: formik.values.companyName || customer?.companyName || '',
                        gstn: formik.values.gstn || customer?.gstn || '',
                        profileImg: data?.data?.url
                    };
                    dispatch(upadteCustomerProfileThunk(updatedValues));
                }
            }
        } catch (err) {
            console.log(err);
            toast.error("Error uploading file")
        } finally {

            setLoading(false);
        }
    };

    const handleRemove = (repo) => {
        formik.setFieldValue(repo, '');
    };

    return (
        <div className={styles.profilebodyContainer}>
            <div className={styles.profileheader}>
                <h2>Account Settings</h2>
            </div>
            <form onSubmit={formik.handleSubmit} className={styles.profilebodyContent}>
                <div className={styles.profilebodyDetails}>
                    <div>
                        <label htmlFor="fullName">Full Name</label>
                        <input
                            type="text"
                            id="fullName"
                            name="fullName"
                            placeholder='Enter'
                            value={formik.values.fullName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.fullName && formik.errors.fullName ? (
                            <div className={styles.error}>{formik.errors.fullName}</div>
                        ) : null}
                    </div>

                    <div>
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder='Enter'
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.email && formik.errors.email ? (
                            <div className={styles.error}>{formik.errors.email}</div>
                        ) : null}
                    </div>

                    <div>
                        <label htmlFor="phone">Phone Number</label>
                        <input
                            type="tel"
                            id="phone"
                            name="phone"
                            placeholder='Enter'
                            value={formik.values.phone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.phone && formik.errors.phone ? (
                            <div className={styles.error}>{formik.errors.phone}</div>
                        ) : null}
                    </div>

                    <div>
                        <label htmlFor="companyName">Company</label>
                        <input
                            type="text"
                            id="companyName"
                            name="companyName"
                            placeholder='Enter'
                            value={formik.values.companyName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.companyName && formik.errors.companyName ? (
                            <div className={styles.error}>{formik.errors.companyName}</div>
                        ) : null}
                    </div>

                    <div>
                        <label htmlFor="gstn">GST</label>
                        <input
                            type="text"
                            id="gstn"
                            name="gstn"
                            placeholder='Enter'
                            value={formik.values.gstn}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.gstn && formik.errors.gstn ? (
                            <div className={styles.error}>{formik.errors.gstn}</div>
                        ) : null}
                    </div>

                    <button type="submit" className={styles.savechanges} disabled={basicDetailsLoading}>
                        {basicDetailsLoading ? 'please wait...' :  'Save Changes'}
                    </button>
                </div>


            </form>
        </div>
    );
};

export default AccountSettings;
